// Module
var code = "<p>Set a timer in seconds for when to display the countdown notice.</p> <p><strong>Note:</strong> This timer cannot be less than 3 seconds.</p> ";
// Exports
module.exports = code;